import type {
  PublishedAttributeFormatted,
  PublishedAttributeGroupingFormatted,
  PublishedAttributeObjectType,
} from '@usealloy/policy-lib/workflows';
import { PUBLISHED_ATTRIBUTE_OBJECT_TYPES } from '@usealloy/policy-lib/workflows';

// temporary re-exports to keep the existing Daffy import paths while these types move to policy-lib
export {
  PUBLISHED_ATTRIBUTE_DATA_TYPES,
  PUBLISHED_ATTRIBUTE_OBJECT_TYPES,
  PublishedAttributeOwnerType,
} from '@usealloy/policy-lib/workflows';
export type {
  PublishedAttributeDataType,
  PublishedAttributeFormatted,
  PublishedAttributeGroupingFormatted,
  PublishedAttributeGroupingUnformatted,
  PublishedAttributeObjectType,
  PublishedAttributeSourceMeta,
  PublishedAttributeUnformatted,
} from '@usealloy/policy-lib/workflows';

export const isPublishedAttributeObjectType = (
  value: unknown,
): value is PublishedAttributeObjectType => (
  PUBLISHED_ATTRIBUTE_OBJECT_TYPES.some(objectType => objectType === value)
);

export type TableProps = {
  attributes: {
    data: PublishedAttributeFormatted[];
    isLoading: boolean;
    error: boolean;
  };
  attributeGroupings: {
    data: PublishedAttributeGroupingFormatted[];
    isLoading: boolean;
    error: boolean;
  };
};
